









































































































import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';
import SingleText from '@/components/common/elements/SingleText.vue';
import Button from '@/components/common/elements/Button.vue';
import Table from '@/components/common/elements/Table.vue';
import DialogMasterSelectMultiControlTable from '@/components/common/modules/DialogMasterSelectMultiControlTable.vue';
import NoteDialog from '@/components/common/modules/NoteDialog.vue';
import { TableParameters } from '@/constants/components/table';
import CheckBox from '@/components/common/elements/CheckBox.vue';

@Component({
  components: {
    SingleText,
    Button,
    Table,
    DialogMasterSelectMultiControlTable,
    NoteDialog,
    CheckBox
  }
})
export default class ListDisplay extends Vue {
  // 表示する表名
  @Prop({ default: '' })
  private listName!: string;
  // 表の上部に表示するボタン名(帳票出力など)
  // ボタン名がない場合は非表示
  @Prop({ default: '' })
  private formOutputButtonName!: string;
  // 一覧を非表示にする場合はfalseを設定
  @Prop({ default: true })
  private panelBoxflag?: boolean;
  // Tableコンポーネント内で使用するパラメータ(カラム、データ、表示用のパラメータ)
  @Prop({ default: () => ({}) })
  private tableParameters?: TableParameters;
  // マスター参照で使用するアイテム(カラム、データ、検索アイテム(大項目、小項目))
  @Prop({ default: () => undefined })
  private masterSelectItem: any;
  // v-data-tableで使用するheaderの横幅を親コンポーネントで算出して、
  // 値が更新されるとv-data-table上部にスクロールを表示する
  // 値をWatchしているので値が更新されたタイミングでスクロールバーを作成
  @Prop({ default: () => ({ 'targetname':'', 'width': 0 }) })
  private subHeadersScrollWidthData!: any;
  // 項目追加ボタンの表示・非表示
  @Prop({ default: false })
  private isAddItemButtonFlag!: boolean;
  // 見積明細項目追加ボタンの表示・非表示
  @Prop({ default: false })
  private isEstimateAddItemButtonFlag!: boolean;
  // ダイアログのエリア外を押下した際にBOXを閉じるか
  @Prop({ default: true })
  private isPersistent?: boolean;
  // 親コンポーネントと同期するための値
  @Prop({ default: () => ({}) })
  private parentRegistData: any;
  // 備考ダイヤログのタイトル設定
  @Prop({ default: '備考欄' })
  private noteDialogTitle!: string;
  // 備考ダイヤログのname設定
  @Prop({ default: '備考' })
  private noteDialogName!: string;
  // チェックボックスを使用する場合のデータ
  @Prop({ default: () => undefined })
  private checkBoxsData?: any;
  //備考ダイヤログの編集可不可フラグ(編集可：false、編集不可：true)
  @Prop({ default: false })
  private isDisabledNoteEdit?: boolean;
  // 登録用データ
  private registData: any = {};
  // マスタ参照用モーダルの開閉ステータス
  private masterSelectDialogStatus = false;
  // 備考用モーダルの開閉ステータス
  private noteDialog = false;
  // 備考用モーダルの表示
  private noteValue = '';
  // ダイアログを開く前に選択した項目情報を控える
  private responseCopy: any = {};

  /**
   * mounted時に上部スクロールバーの設定値などがあれば、
   * v-data-table上部のスクロールバーに値とイベントをセットする
   * @module mounted
   */
  mounted() {
    if (this.listName === this.subHeadersScrollWidthData['targetName']) {
      const dataTable: any = this.$refs.dataTable;
      this.setScrollWidth(
        dataTable.$el.childNodes[0],
        this.$refs.upperscrollbar,
        this.$refs.upperscrollbarinner,
        this.subHeadersScrollWidthData['width']
      );
    }
  }

  /**
   * subHeadersScrollWidthData.widthの値が更新されたタイミングで
   * v-data-table上部のスクロールバーに値とイベントをセットする
   * @module setSubHeadersScrollWidthData
   */
  @Watch('subHeadersScrollWidthData.width')
  setSubHeadersScrollWidthData() {
    if (this.listName === this.subHeadersScrollWidthData['targetName']) {
      const dataTable: any = this.$refs.dataTable;
      this.setScrollWidth(
        dataTable.$el.childNodes[0],
        this.$refs.upperscrollbar,
        this.$refs.upperscrollbarinner,
        this.subHeadersScrollWidthData['width']
      );
    }
  }

  /**
   * 上部スクロールバーの横幅をpxでセット
   * 上部下部スクロールバーの位置を同期させるためのイベント追加
   * @module setScrollWidth
   * @param BaseScrollBar -ベースとなるスクロールバー
   * @param setScrollBar - 上部スクロールバー
   * @param setInner - 上部スクロールバーの横幅を設定するコンテンツ
   * @param width - 設定する上部スクロールバーの横幅
   */
  private setScrollWidth(BaseScrollBar: any, setScrollBar: any, setInner: any, width: number) {
    setInner.style.width = String(width + 'px');
    BaseScrollBar?.addEventListener('scroll', function() {
      const left: any = BaseScrollBar?.scrollLeft;
      setScrollBar?.scrollTo(left, 0);
    });
    setScrollBar?.addEventListener('scroll', function() {
      const left: any = setScrollBar?.scrollLeft;
      BaseScrollBar?.scrollTo(left, 0);
    });
  }

  /**
   * 出力ボタン押下で子コンポーネントからEmitされた値を親コンポーネントにEmitで返す
   * @module clickFormOutputButton
   * @param response - 子コンポーネントのボタンイベント
   * @return string - 表名
   */
  @Emit('clickFormOutputButton')
  public clickFormOutputButton(response: any) {
    return { listName: this.listName };
  }

  /**
   * 表内の入力で子コンポーネントからEmitされた値を親コンポーネントにEmitで返す
   * @module getData
   * @param response - 子コンポーネントの入力イベント
   * @return response - 表名を追加した入力イベント
   */
  @Emit('getData')
  getData(response: any) {
    response.listName = this.listName;
    return response;
  }

  /**
   * 表内ボタン押下で子コンポーネントからEmitされた値を親コンポーネントにEmitで返す
   * @module clickButton
   * @param response - 子コンポーネントのボタンイベント
   * @return { record, buttonName, itemIndex }
   */
  @Emit('clickButton')
  clickButton(response: any) {
    switch (response.buttonName) {
      case 'selectButtonIndex': {
        // マスタ参照
        // ダイアログを開く前に選択した項目情報を控える
        response.listName = this.listName;
        this.responseCopy = response;
        this.masterSelectDialogStatus = true;
        break;
      }
      case 'taxClassificationButton': {
        // マスタ参照
        // ダイアログを開く前に選択した項目情報を控える
        response.listName = this.listName;
        this.responseCopy = response;
        this.masterSelectDialogStatus = true;
        break;
      }
      case 'note':
      case 'remarks': {
        // 備考
        // 備考の編集可不可確認
          if (this.tableParameters?.isDisabledNoteEdit === undefined || this.tableParameters?.isDisabledNoteEdit === false) {
            // テーブルのパラメータが編集可で行ごとに編集可不可の確認
            if (response.record['edit_material_flag'] === undefined || response.record['edit_material_flag'] === true) {
              this.isDisabledNoteEdit = false;
            } else if (response.record['edit_material_flag'] === false) {
              this.isDisabledNoteEdit = true;
            } else {
              this.isDisabledNoteEdit = false;
            }
          } else {
            this.isDisabledNoteEdit = true;
          }

        // ダイアログを開く前に選択した項目情報を控える
        this.responseCopy = response;
        this.noteValue = response.record[response.buttonName];
        this.noteDialog = true;
        break;
      }
      case 'deleteButton': {
        //削除ボタン(DEL)
        this.getData(response);
        break;
      }
      case 'copyButton': {
        //項目コピーボタン(COPY)
        this.getData(response);
        break;
      }
      default: {
        return response;
      }
    }
  }

  /**
   * マスタ参照で選択した内容をリスト項目選択時の内容とともに親コンポーネントに返す
   * @module catchTableDataRelay
   * @param {any} response - 子コンポーネントより渡される値
   * @return response - 子コンポーネントから渡された値とモーダル表示前の選択した項目情報
   */
  @Emit('catchTableDataRelay')
  public catchTableDataRelay(response: any) {
    this.masterSelectDialogStatus = false;
    return { selectData: response.selectData, selectRowData: this.responseCopy };
  }

  /**
   * 項目追加ボタン押下時の情報を親コンポーネントに返す
   * @module catchTableDataRelay
   * @param {any} response - 子コンポーネントより渡される値
   * @return response - {表示している表名、 ボタン名}
   */
  @Emit('clickItemAdditionButton')
  clickItemAdditionButton(response: any) {
    return { listName: this.listName, buttonName: 'addListItem' };
  }

  /**
   * 備考モーダルで入力された内容をgetDataを経由して、親コンポーネントに返す
   * @module inputOperationNote
   * @param {any} response - 子コンポーネントより渡される値
   * @return response - {表示している表名、 ボタン名}
   */
  @Emit('inputOperationNote')
  inputOperationNote(response: any) {
    this.noteValue = response.value;
    this.getData({
      inputName: this.responseCopy.buttonName,
      inputValue: response.value,
      itemIndex: this.responseCopy.itemIndex,
      record: this.responseCopy.record
    });
  }

  /**
   * 親コンポーネントに押下した行を通知する
   * @module clickRowOpratiponRelay
   * @param  { [k: string]: string } - 対象行データ
   * @return { [k: string]: string } - 押下された行データ
   */
  @Emit('clickRowOpratiponRelay')
  public clickRowOpratiponRelay(clickRecord: { [k: string]: string }): { [k: string]: string } {
    return clickRecord;
  }

  /**
   * 親コンポーネントに選択したラジオボタンの内容を通知する
   * @module clickFormRadioArea
   * @param  { [k: string]: string } - 選択されたラジオボタンのデータ
   * @return { [k: string]: string } - 選択されたラジオボタンのデータ
   */
  @Emit('clickFormCheckBox')
  public clickFormCheckBox(response: any) {
    response.listName = this.listName;
    return response;
  }

  /**
   * 備考用モーダルを閉じ、編集文言を初期化
   */
  private closeNoteDialog() {
    this.noteDialog = false;
  }
}
